import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { NetworkLoaded } from "./Input-param-state";

export interface OnlineNetworkItems {
    network_uuid: string,
        name: string,
        description: string,
        bbox: {
        min_lon: 0,
        min_lat: 0,
        max_lon: 0,
        max_lat: 0
        },
    feature_count: 0,
    metadata_types: string[],
    updated_at: string
}

export interface ApplicationState {
    application_mode: 'online' | 'offline',
    onlineNetworks: OnlineNetworkItems[] | []
    selectedOnlineNetwork: any;
    selectedMarker: string | null;
    networkLoaded: NetworkLoaded,
    setSelectedOnlineNetwork: (item: any) => void;
    setMode: (state: 'online' | 'offline') => void
    setOnlineNetworks: (item: OnlineNetworkItems[] | []) => void
    clearDetails: () => void
    setSelectedMarker: (id: string | null) => void
    setNetworkLoaded: (networkId: string, type: boolean) => void;
}

export const useApplicationState = create<ApplicationState>()(
//    devtools(
    (set) => ({
        application_mode: 'offline',
        onlineNetworks: [],
        selectedOnlineNetwork: {
                type: "FeatureCollection",
                features: [],
        },
        selectedMarker: null,
        networkLoaded: {},
        setSelectedOnlineNetwork: (item: any) => {
            set(() => ({selectedOnlineNetwork: item}));
        },
        setMode: (mode: 'online' | 'offline') => {
            set(() => ({application_mode: mode}));
        },
        setOnlineNetworks: (item: OnlineNetworkItems[] | []) => {
            set(() => ({onlineNetworks: item}));
        },
        setSelectedMarker: (item: string | null) => {
            set(() => ({selectedMarker: item}));
        },
        clearDetails: () => {
            set((state) => ({
                ...state, onlineNetworks: [], selectedOnlineNetwork: {
                    type: "FeatureCollection",
                    features: [],
                },
                application_mode: 'offline',
                selectedMarker: null
            }))
        },
        setNetworkLoaded: (networkId: string, type: boolean) => {
            set((state) => ({
                networkLoaded: {
                    ...state.networkLoaded,
                    [networkId]: type,
                },
            }));
        },
    })
)
//)